export const payments = '/payments';
export const download = 'payments/download';
